import { Method as apiMethod } from 'axios'

export const generalEndpoints = {
  reTryErpSync: {
    method: 'post' as apiMethod,
    url: '/general/retry_erp_failed_sync'
  }
}
